import React from "react";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="container py-12">
        <div className="flex items-center justify-center gap-6 text-sm text-gray-600 mb-6">
          <Link
            to="home"
            smooth
            duration={500}
            offset={-80}
            className="hover:text-black cursor-pointer"
          >
            Home
          </Link>
          <Link
            to="about"
            smooth
            duration={500}
            offset={-80}
            className="hover:text-black cursor-pointer"
          >
            About Us
          </Link>
          <Link
            to="project"
            smooth
            duration={500}
            offset={-80}
            className="hover:text-black cursor-pointer"
          >
            Project
          </Link>
          <Link
            to="services"
            smooth
            duration={500}
            offset={-80}
            className="hover:text-black cursor-pointer"
          >
            Service
          </Link>
          <Link
            to="contact"
            smooth
            duration={500}
            offset={-80}
            className="hover:text-black cursor-pointer"
          >
            Contact
          </Link>
        </div>
        
        <div className="text-center text-gray-900 font-extrabold tracking-wide mb-2">
          TRUST IMPLEX <span className="font-semibold text-gray-600"></span>
        </div>
        <p className="text-center text-gray-500">
          ©{new Date().getFullYear()} All Copyrights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
